export default "__VITE_ASSET__Coch5XKX__"